import React from 'react'
import { Row, Col, Form, Button, Card } from 'react-bootstrap'
import MaskedInput from 'react-text-mask'
import MomentUtils from '@date-io/moment'
import { isValidCpf } from '@brazilian-utils/is-valid-cpf'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import 'moment/locale/pt-br'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

class Dependentes extends React.Component {
  state = { invalidCPF: false }

  onBlurCPF = (e) => {
    this.onChange(e)
    this.setState({ invalidCPF: !isValidCpf(e.target.value) && e.target.value.length > 0 })
  }

  onChangeDate = (date) => {
    const { index, dependente } = this.props
    dependente.dataNascimento = date
    this.props.onChange(index, dependente)
  }

  onChange = (e) => {
    const { index, dependente } = this.props
    dependente[e.target.name] = e.target.value
    this.props.onChange(index, dependente)
  }

  renderFields() {
    const { dependente, index, disableAll } = this.props
    return (
          <Row className="form-row align-items-end">
            <Col xs={12} md={6} lg={4}>
              <Form.Group className="required mb-2 mb-md-0">
                <Form.Label htmlFor={`dep-nome-${index}`} className="mb-1">
                  Nome
                </Form.Label>
                <Form.Control
                  type="text"
                  id={`dep-nome-${index}`}
                  name="nome"
                  value={dependente.nome}
                  onChange={this.onChange}
                  maxLength={100}
                  disabled={disableAll}
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Form.Group className="required mb-2 mb-md-0">
                <Form.Label htmlFor={`dep-dn-${index}`} className="mb-1">
                  Data de nascimento
                </Form.Label>
                <MuiPickersUtilsProvider utils={MomentUtils} locale="pt-br">
                  <KeyboardDatePicker
                    invalidDateMessage="Formato de data inválido"
                    id={`dep-dn-${index}`}
                    name="dataNascimento"
                    className={'form-control ' + (disableAll ? 'disabled-datepicker' : '')}
                    value={dependente.dataNascimento}
                    onChange={(date) => this.onChangeDate(date)}
                    variant="inline"
                    format="DD/MM/YYYY"
                    animateYearScrolling
                    disableFuture
                    autoOk
                    disabled={disableAll}
                  />
                </MuiPickersUtilsProvider>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <Form.Group className="mb-2 mb-md-0">
                <Form.Label htmlFor={`dep-cpf-${index}`}>CPF</Form.Label>
                <MaskedInput
                  mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                  className={this.state.invalidCPF ? 'form-control is-invalid' : 'form-control'}
                  id={`dep-cpf-${index}`}
                  name="cpf"
                  value={dependente.cpf}
                  onChange={this.onChange}
                  onBlur={this.onBlurCPF}
                  disabled={disableAll}
                />
                {this.state.invalidCPF && <div className="invalid-feedback">Digite um CPF válido.</div>}
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <Form.Group className="mb-0">
                <Form.Label htmlFor={`dep-rg-${index}`}>RG</Form.Label>
                <Form.Control
                  type="text"
                  id={`dep-rg-${index}`}
                  name="rg"
                  value={dependente.rg}
                  onChange={this.onChange}
                  maxLength={100}
                  disabled={disableAll}
                />
              </Form.Group>
            </Col>
          </Row>
    )
  }

  render() {
    const { dependente, removeDependente, index, disableAll, embedded } = this.props
    const showRemove = !dependente.id && !disableAll

    if (embedded) {
      return <div className="paciente-dependente-embedded">{this.renderFields()}</div>
    }

    return (
      <Card className="paciente-dependente-card border mb-2">
        <Card.Body className="py-2 px-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted font-weight-normal" style={{ fontSize: '0.8125rem' }}>
              Dependente {index + 1}
            </span>
            {showRemove && (
              <Button
                type="button"
                variant="outline-danger"
                size="sm"
                onClick={() => removeDependente(index)}
                className="py-0 px-2"
              >
                <FontAwesomeIcon icon={faTrashAlt} className="mr-1" />
                Excluir
              </Button>
            )}
          </div>

          {this.renderFields()}
        </Card.Body>
      </Card>
    )
  }
}

export default Dependentes
